import { ListService, PagedResultDto } from '@abp/ng.core';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { debounceTime, finalize } from 'rxjs';
import { DateAdapter } from '@abp/ng.theme.shared/extensions';
import { NgbDateAdapter } from '@ng-bootstrap/ng-bootstrap';
import { LocationTreeNode } from '@/locations/models/location-tree-node.model';
import { LocationDefinition, LocationService } from '@register/proxy/register-service/locations';

@Component({
  selector: 'app-locations-with-search',
  templateUrl: './locations-with-search.component.html',
  styleUrls: ['./locations-with-search.component.scss'],
  providers: [ListService, { provide: NgbDateAdapter, useClass: DateAdapter }],
})
export class LocationsWithSearchComponent implements OnInit {
  @Input() readonly: boolean = true;
  @Input() showSearch: boolean = true;
  @Input() locationDefinition: LocationDefinition | undefined = undefined;
  @Input() selectedLocation: LocationTreeNode | undefined = undefined;
  @Input() hasAssociatedInspections: boolean | undefined = undefined;
  @Input() hasAssociatedAssets: boolean | undefined = undefined;
  @Input() withLookup: boolean = false;
  @Input() displayHeaders: boolean = false;
  @Input() checkable: boolean = false;
  @Input() checkStrictly: boolean = false;
  @Input() pinOrKeyringPassword: string = '';
  @Input() isGuest: boolean = false;
  @Input() showTransferNotes: boolean = false;
  @Input() showSubAssetsNotes = false;
  @Input() transferNotes: string = '';
  @Input() subAssetsNotes: string = '';

  @Output() transferNotesChange = new EventEmitter<string>();
  @Output() subAssetsNotesChange = new EventEmitter<string>();
  @Output() selectedNodeChange = new EventEmitter<LocationTreeNode>();
  @Output() checkedKeysChange = new EventEmitter<string[]>();

  isModalOpen = false;
  isLoading = false;
  data: PagedResultDto<any> = {
    items: [],
    totalCount: 0,
  };

  form: FormGroup = new FormGroup({
    term: new FormControl(),
  });

  constructor(
    public readonly list: ListService,
    public readonly service: LocationService,
  ) {}

  ngOnInit(): void {
    this.isLoading = true;
    this.form
      .get('term')!
      .valueChanges.pipe(debounceTime(250))
      .subscribe(searchTerm => this.loadData(searchTerm || ''));
  }

  private loadData(searchTerm: string): void {
    this.isLoading = true;
    this.service
      .getLookup(
        {
          maxResultCount: 100,
          filter: searchTerm,
          locationDefinition: this.locationDefinition,
          hasAssociatedInspections: this.hasAssociatedInspections,
          hasAssociatedAssets: this.hasAssociatedAssets,
          skipCount: 0,
          pinOrKeyringPassword: this.pinOrKeyringPassword,
        },
        undefined,
        this.isGuest,
      )
      .pipe(finalize(() => (this.isLoading = false)))
      .subscribe(data => {
        const isSearching = searchTerm && searchTerm.trim();
        if (isSearching && data.items?.length) {
          this.data = {
            ...data,
            items: data.items.map((item: any) => ({ ...item, parentId: null })),
          };
        } else {
          this.data = data;
        }
      });
  }

  onSelectedNodeChange($event: LocationTreeNode) {
    this.selectedNodeChange.emit($event);
  }

  onCheckedKeysChange($event: string[]) {
    this.checkedKeysChange.emit($event);
  }
}
